// @generated by protobuf-ts 2.11.1 with parameter output_javascript
// @generated from protobuf file "call_window.proto" (syntax proto3)
// tslint:disable
import { CallWindowService } from "./call_window";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service CallWindowService
 */
export class CallWindowServiceClient {
    constructor(_transport) {
        this._transport = _transport;
        this.typeName = CallWindowService.typeName;
        this.methods = CallWindowService.methods;
        this.options = CallWindowService.options;
    }
    /**
     * @generated from protobuf rpc: CreateCallWindow
     */
    createCallWindow(input, options) {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetCallWindow
     */
    getCallWindow(input, options) {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: BatchGetCallWindow
     */
    batchGetCallWindow(input, options) {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCallWindow
     */
    updateCallWindow(input, options) {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeleteCallWindow
     */
    deleteCallWindow(input, options) {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
}
